export default {
  inject: ['load'],
  data() {
    return {
      allChestPainDurationsForOther: [],
      chestPainDuration: null,
    };
  },
  methods: {
    getListOfChestPainDurationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllChestPainDurations').then(() => {
        if (this.$store.state.chestPainDurationModule.successFlag) {
          this.allChestPainDurationsForOther =
            this.$store.state.chestPainDurationModule.allChestPainDurations;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chestPainDurationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfChestPainDurationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getChestPainDurationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getChestPainDuration', id).then(() => {
        if (this.$store.state.chestPainDurationModule.successFlag) {
          this.chestPainDuration = this.$store.state.chestPainDurationModule.chestPainDuration;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chestPainDurationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getChestPainDurationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.chestPainDurationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
